import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomCreateAiMappingRunAreaMutation } from "generated/graphql";

export const useCreateAiMappingRunArea = () => {
  const [mutation, { data, loading, error }] = useCustomCreateAiMappingRunAreaMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "createAiMappingRunArea" },
    { hideMessage: true }
  );
};
